<template>
  <div class="p-3">
    <div>
      <slot name="filters"></slot>
    </div>
    <iframe class="border-0 w-100 insights-iframe"
            frameborder="0"
            allowTransparency="true"
            onload="iFrameResize({}, this)"
            :src="urlWithQuery"/>
  </div>
</template>
<style scoped>
.insights-iframe{
  min-height: 100vh;
}
</style>
<script>
export default {
  name: 'insights-show',
  props: {
    url: {
      type: String,
      default: null
    },

    query: {
      type: Object,
      default: null
    },

    splitDateFilter: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    // Inject iframeResizer from Meta to expand iframe's height accordingly
    let iframeResizerScript = document.createElement('script')
    iframeResizerScript.setAttribute('src', `${localStorage.getItem('metabase_site_url')}/app/iframeResizer.js`)
    document.head.appendChild(iframeResizerScript)
  },

  computed: {
    urlWithQuery() {
      if (this.query) {
        const cleanQuery = this.cleanQuery(this.query)
        const urlBase = this.url.split('#')[0]
        const parameters = new URLSearchParams(this.url.split('#')[1])
        let query = new URLSearchParams(cleanQuery)
        query = this.formattedQuery(query)

        let keys = Object.keys(this.query).join(',')
        if (this.splitDateFilter) {
          keys += ',start_date,end_date'
        }
        parameters.append('hide_parameters', keys)

        return this.url ? `${urlBase}?${query}#${parameters.toString()}` : ''
      } else {
        return this.url
      }
    }
  },

  methods: {
    formattedQuery (query) {
      Object.keys(this.query).forEach(key => {
        const value = this.query[key]
        if (Array.isArray(value)) {
          query.delete(key)
          value.forEach(param => {
            query.append(key, param)
          })
        }

        if (this.splitDateFilter && key === 'date_filter') {
          query.delete(key)
          const date = value.split('~')
          query.append('start_date', date[0])
          query.append('end_date', date[1])
        }
      })

      return query.toString()
    },

    cleanQuery (query) {
      return Object.fromEntries(
          Object.entries(query).filter(([_, value]) =>
              value !== null &&
              value !== undefined &&
              value !== '' &&
              !(Array.isArray(value) && value.length === 0)
          )
      )
    }
  }
}
</script>
